// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","links":"Footer_links__wMgLO","link":"Footer_link__3Ie8d","copyright":"Footer_copyright__JQMtz"};